import rice from './rice.jpg';
import sugarcane from './sugarcane.jpg';
import cotton from './cotton.jpg';
import banana from './banana.webp';
import beans from './beans.jpg';
import beetroot from './beetroot.webp';
import blackgram from './blackgram.jpg';
import brinjal from './brinjal.jpg';
import carrot from './carrot.jpg';
import chili from './chili.webp';
import Coconut from './Coconut.jpg';
import coffee from './coffee.jpg';
import coriander from './coriander.jpg';
import cucumber from './cucumber.jpg';
import FingerMillet from './Finger-Millet.jpg';
import greengram from './greengram.jpg';
import groundnut from './groundnut.webp';
import guava from './guava.webp';
import maize from './maize.webp';
import mango from './mango.jpg';
import onion from './onion.webp';
import pearl_millet from './pearl_millet.jpg';
import potato from './potato.jpg';
import sesame from './sesame.jpg';
import sorghum from './sorghum.webp';
import sunflower from './sunflower.jpg';
import tapioca from './tapioca.jpg';
import tea from './tea.jpg';
import tomato from './tomato.jpg';
import turmeric from './turmeric.jpg';
import wheat from './wheat.jpg';
import barley from './barley.jpg';
import oats from './oats.jpg';
import rye from './rye.jpg';
import millet from './millet.jpg';
import littlemillet from './littlemillet.jpg';
import foxtailmillet from './foxmillet.jpg';
import pomagranate from './pomegranate.jpg';
import custardapple from './custardapple.jpg';
import drumstick from './moringa.jpg';
import sapota from './sapota.jpg';
import bittergourd from './bittergourd.jpg';
import bottlegourd from './bottlegourd.jpg';
import snakegourd from './snakegourd.jpg';
import ridgegourd from './ridgegourd.jpg';
import clusterbeans from './clusterbeans.jpg';
import indianspinach from './indianspinach.jpg';
import amaranthus from './amaranthus.jpg';
import colocosia from './colocasia.jpg';
import elephantfootyam from './elephantfootyam.jpg';

const imageMap = {
  "clusterbeans.jpg":clusterbeans,
  "indanspinach.jpg":indianspinach,
  "amaranthus.jpg":amaranthus,
  "colocasia.jpg":colocosia,
  "elephantfootyam.jpg":elephantfootyam,
  "custardapple.jpg":custardapple,
  "moringa.jpg":drumstick,
  "sapota.jpg":sapota,
  "bittergourd.jpg":bittergourd,
  "bottlegourd.jpg":bottlegourd,
  "ridgegourd.jpg":ridgegourd,
  "snakegourd.jpg":snakegourd,
  "rye.jpg":rye,
  "millet.jpg":millet,
  "littlemillet.jpg":littlemillet,
  "foxmillet.jpg":foxtailmillet,
  "pomegranate.jpg":pomagranate,
  "oats.jpg":oats,
  "barley.jpg":barley,
  "wheat.jpg":wheat,
  "rice.jpg": rice,
  "sugarcane.jpg": sugarcane,
  "cotton.jpg": cotton,
  "turmeric.jpg":turmeric,
  "tomato.jpg":tomato,
  "tea.jpg":tea,
  "tapioca.jpg":tapioca,
  "sunflower.jpg":sunflower,
  "sorghum.webp":sorghum,
  "sesame.jpg":sesame,
  "potato.jpg":potato,
  "pearl_millet.jpg":pearl_millet,
  "onion.webp":onion,
  "mango.jpg":mango,
  "maize.webp":maize,
  "guava.webp":guava,
  "groundnut.webp":groundnut,
  "greengram.jpg":greengram,
  "Finger-Millet.jpg":FingerMillet,
  "cucumber.jpg":cucumber,

  "coriander.jpg":coriander,
  "coffee.jpg":coffee,
  "Coconut.jpg":Coconut,
  "chili.webp":chili,
  "carrot.jpg":carrot,
  "brinjal.jpg":brinjal,
  "balckgram.jpg":blackgram,
  "beetroot.webp":beetroot,
  "beans.jpg":beans,
  "banana.webp":banana,

  
  // Add more mappings
};

export default imageMap;

